export const organizations = {
  title: 'All organizations',
  new: 'New organization',
  createInfo: 'Create a new organization by entering a name. The other data will be added later.',
  deleteModal: {
    title: 'Organization deletion',
    message: 'Are you sure you want to delete this organization?',
  },
  filters: {
    allOwners: 'All owners',
  },
  roles: {
    owner: 'Owner',
    administrator: 'Administrator',
    member: 'Member',
    members: 'Members',
    user: 'User',
    invited: 'Invited'
  },
  buttons: {
    new: 'New organization',
    cancel: 'Cancel',
    create: 'Create',
    edit: 'Edit',
    saveChanges: 'Save changes',
    cancelChanges: 'Cancel',
    editDetails: 'Edit',
  },
  fields: {
    name: 'Name',
    regNumber: 'Reg. number',
    organizationDetails: 'Organization details',
    cancelChanges: 'Cancel',
    saveChanges: 'Save changes',
    owner: 'Owner',
    taxNumber: 'Tax number',
    email: 'Email',
    phone: 'Phone',
    company: {
      title: 'Company details',
      name: 'Company name',
      taxNumber: 'Tax number',
      address: 'Address',
      registrationNumber: 'Registration number',
    },
    address: {
      title: 'Registered address',
      location: 'Location',
      address: {
        street: 'Street',
        city: 'City',
        postalCode: 'Postal code',
        country: 'Country',
      }
    },
    contact: {
      title: 'Contact',
      contact: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        position: 'Position',
      }
    },
    logo: {
      organizationLogo: 'Organization logo',
      noLogo: 'No logo',
      chooseLogoFile: 'Choose logo file',
      recommendedSize: `Recommended size: 400x400px. Max. file size: 2MB.
      Supported formats: PNG, JPG, JPEG.`,
    },
    users: {
      title: 'Organization users',
      add: 'Add user',
      remove: 'Remove user',
      confirmRemove: 'Are you sure you want to remove this user from the organization?',
      cancelRemove: 'Cancel',
      confirmRemoveTitle: 'User removal',
    }
  },
  messages: {
    createdSuccess: 'Organization created successfully',
    createdError: 'Error occurred while creating the organization',
    updatedSuccess: 'Organization updated successfully',
    updatedError: 'Error occurred while updating the organization',
    deletedSuccess: 'Organization deleted successfully',
    deletedError: 'Error occurred while deleting the organization',
    nameRequired: 'Organization name is required',
    confirmTitle: 'Organization deletion',
    deleteQuestion: 'Are you sure you want to delete this organization?',
    deleteWarning: 'This action cannot be undone.'
  }
}